//*** Import React Library
import axios from "axios";
import { Button } from "bootstrap";
import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
import AxiosInstance from '../Axios/AxiosInstance';
export const ChartCurrentPlantLevelSpraying = () => {
    const role_id = sessionStorage.getItem("role_id");
    const [chartData, setChartData] = useState({});
    const [data, setData] = useState([]);
    const areaCovered = [];
    const workingDate = [];
    const robotName = [];

    const GetCurrentPlantLevelSpraying = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        //let response = await axios("/PlantLevelCurrentSprayingStatus?pid=" + plant_id + "");
        try {
            let response = await AxiosInstance.get("/PlantLevelCurrentSprayingStatus?pid=" + plant_id + "");
            if (response && typeof response.then === 'function') {
            response.then((res) => {
                if (res.data) setData(response.data);
            })
            response.catch(
                function (error) {
                    console.log('Error Message:' + error)
                }
                ) 
            }
            else {
                console.log("Response is not a promise");
            }
        }
        catch (error) {
            console.log('Error Message:' + error)
        }
        data.map((user) => {
            areaCovered.push(user.areaCovered);
            workingDate.push(user.workingDate);
        });
        //*** Set Chart Data
        setChartData({
            labels: workingDate,
            datasets: [
                {
                    label: "Area Covarage in Meter (m) By Current Date",
                    data: areaCovered, //[0, 10, 5, 2, 20, 30, 45],
                    backgroundColor: ["rgba(255, 206, 86, 0.2)"], //"lemonyellow", //"#5ADEFF",
                    borderColor: ["rgba(255, 99, 132, 1)"],
                    borderWidth: 1
                }
            ]
        });
    };
     //*** Use React hooks - if occur any changes on page then useffect() function will run auto
    useEffect(() => {
        GetCurrentPlantLevelSpraying();
    }, []);
    useEffect(() => {
        console.log(data)
    }, [data])
    GetCurrentPlantLevelSpraying();
    // *** Return html code 
    return (
    <>
        {hasJWTToken()  ? (
          <div className="App1">
            {/*<p>&nbsp;</p>*/}
            {/*<p>&nbsp;</p>*/}
            <p></p>
            <h3 style={{ marginLeft: "3%" }}>Current Plant Level Spraying</h3>
            <p></p>
            <p></p>
            {data.map((user) => (
                (user.id === 0 ? (
                    <div key={user.id}>
                        <Bar data={chartData} />
                    </div>
                ) : (<></>))
            ))}
            </div>
            ) :
            (
               /*<Route to={{ pathname: '#/login' }} />*/
               window.location.href = "#/Login"
            )
        }
    </>
  );
};